import { render, staticRenderFns } from "./ModalHistoricoBoleto.vue?vue&type=template&id=3436e097&scoped=true"
import script from "./ModalHistoricoBoleto.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoBoleto.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoBoleto.vue?vue&type=style&index=0&id=3436e097&prod&scoped=true&lang=css"
import style1 from "./ModalHistoricoBoleto.vue?vue&type=style&index=1&id=3436e097&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3436e097",
  null
  
)

export default component.exports